import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import App from '~/javascript/components/phone_numbers/new_phone_number.vue'

export default class extends Controller {
  static values = {
    accounts: Array
  }

  connect() {
    const props = {
      accounts: this.accountsValue
    }

    this.vue = createApp(App, props)
    this.vue.mount(this.element)
  }

  disconnect() {
    this.vue?.unmount()
  }
}
